// Runtime config — single source of truth for all environment-dependent values.
// In production, docker-entrypoint.sh generates /config.js with window.__RUNTIME_CONFIG__.
// In local dev, falls through to import.meta.env.VITE_* then hardcoded defaults.

interface RuntimeConfig {
  API_URL: string;
  WS_URL: string;
  TENANT_NAME: string;
  TENANT_LOGO: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

function get(key: keyof RuntimeConfig, fallback: string): string {
  return window.__RUNTIME_CONFIG__?.[key]
    || import.meta.env[`VITE_${key}`]
    || fallback;
}

export const config: RuntimeConfig = {
  API_URL:     get('API_URL',     'http://localhost:7080/api'),
  WS_URL:      get('WS_URL',      'http://localhost:7081'),
  TENANT_NAME: get('TENANT_NAME', 'DJIN Cloud'),
  TENANT_LOGO: get('TENANT_LOGO', '/djin-logo.png'),
};

// Feature flags are added here as they land; downstream callers should keep
// importing from here so future flags can be managed from one place.
export const featureFlags = {};
